module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('g', {
    staticClass: "spots"
  }, [_vm._l((_vm.spots), function(spot) {
    return [(_vm.isUnSelectedSpotPin(spot)) ? _c('visualization-pin', {
      key: spot.id,
      attrs: {
        "spot": spot
      }
    }) : _vm._e()]
  }), _vm._v(" "), (_vm.selectedSpotPin) ? _c('visualization-pin', {
    attrs: {
      "spot": _vm.selectedSpotPin
    }
  }) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-334ccd34","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/map/visualization/pin/spot.vue
// module id = 743
// module chunks = 0